export default __webpack_public_path__ + "static/media/banner-4.320924f2.jpg";